var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropzone',{attrs:{"target":_vm.$parent.$parent.$parent,"validation-fn":_vm.validateDrag},on:{"drop":_vm.onDrop}},[_vm._v(" "+_vm._s(_vm.$t('change font'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }